import { createContext, useContext, useEffect, useState } from "react";
import { storage } from "@/lib/storage";

const CartCtx = createContext(null);

const loadCart = () => {
  try { return JSON.parse(storage.get("tms_cart") || "[]"); } catch { return []; }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(loadCart);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    storage.set("tms_cart", JSON.stringify(items));
  }, [items]);

  const add = (p, qty = 1) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.id === p.id);
      if (ex) return prev.map((i) => (i.id === p.id ? { ...i, quantity: Math.min(20, i.quantity + qty) } : i));
      return [...prev, { id: p.id, name: p.name, price: p.price, image_url: p.image_url, quantity: qty }];
    });
    setOpen(true);
  };
  const setQty = (id, q) =>
    setItems((prev) => prev.map((i) => (i.id === id ? { ...i, quantity: Math.max(1, Math.min(20, q)) } : i)));
  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => setItems([]);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, add, setQty, remove, clear, total, count, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
};

export const useCart = () => useContext(CartCtx);
